import { render } from "./HeaderDefault.vue?vue&type=template&id=1cba7bdc&ts=true"
import script from "./HeaderDefault.vue?vue&type=script&lang=ts"
export * from "./HeaderDefault.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/package/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__